'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.forgotPass = forgotPass;
exports.resetPass = resetPass;
exports.updateUser = updateUser;
exports.sendFeedback = sendFeedback;
exports.activePhone = activePhone;
exports.clearSuccessStatus = clearSuccessStatus;
exports.saveUserLocation = saveUserLocation;

var _localStorage = require('../../utils/localStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE = 'lookme/user/UPDATE';
var UPDATE_SUCCESS = 'lookme/user/UPDATE_SUCCESS';
var UPDATE_FAIL = 'lookme/user/UPDATE_FAIL';
var CLEAR_STATUS = 'lookme/user/CLEAR_STATUS';
var SAVE_USER_LOCATION = 'lookme/user/SAVE_USER_LOCATION';
var FORGOT_PASS = 'lookme/user/FORGOT_PASS';
var FORGOT_PASS_FAIL = 'lookme/user/FORGOT_PASS_FAIL';
var FORGOT_PASS_SUCCESS = 'lookme/user/FORGOT_PASS_SUCCESS';
var RESET_PASS = 'lookme/user/RESET_PASS';
var RESET_PASS_FAIL = 'lookme/user/RESET_PASS_FAIL';
var RESET_PASS_SUCCESS = 'lookme/user/RESET_PASS_SUCCESS';
var SEND_FEEDBACK = 'lookme/user/SEND_FEEDBACK';
var SEND_FEEDBACK_SUCCESS = 'lookme/user/SEND_FEEDBACK_SUCCESS';
var SEND_FEEDBACK_FAIL = 'lookme/user/SEND_FEEDBACK_FAIL';
// const NEW_PASS = 'lookme/user/NEW_PASS';
// const NEW_PASS_FAIL = 'lookme/user/NEW_PASS_FAIL';
// const NEW_PASS_SUCCESS = 'lookme/user/NEW_PASS_SUCCESS';
var initialState = {
  loading: false,
  success: false,
  coords: null,
  isGeoAvailable: false,
  _user: null,
  loadError: null,
  updateUserError: null,
  updateUserSuccess: null,
  sendFeedbackSuccess: null,
  sendFeedbackFail: null,
  loadingSending: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FORGOT_PASS:
      return (0, _extends3.default)({}, state, {
        loadingForgotPass: true
      });
    case FORGOT_PASS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingForgotPass: false
      });
    case FORGOT_PASS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingForgotPass: false,
        messageForgotPass: action.result.message
      });
    case RESET_PASS:
      return (0, _extends3.default)({}, state, {
        loadingResetPass: true
      });
    case RESET_PASS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingResetPass: false
      });
    case RESET_PASS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingResetPass: false,
        _user: action.result.user,
        messageResetPass: action.result.message
      });
    case UPDATE:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loadError: null,
        success: false,
        updateUserError: null,
        updateUserSuccess: null
      });
    case UPDATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        success: true,
        updateUserSuccess: action.result
      });
    case UPDATE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loadError: action.error ? action.error : action,
        loaded: true,
        success: false,
        updateUserError: action.error ? action.error : action
      });
    case CLEAR_STATUS:
      return (0, _extends3.default)({}, state, {
        success: false
      });
    case SAVE_USER_LOCATION:
      return (0, _extends3.default)({}, state, {
        isGeoAvailable: true,
        coords: action.payload
      });
    case SEND_FEEDBACK:
      return (0, _extends3.default)({}, state, {
        loadingSending: true,
        sendFeedbackSuccess: false,
        sendFeedbackFail: null
      });
    case SEND_FEEDBACK_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingSending: false,
        sendFeedbackSuccess: true,
        sendFeedbackFail: action.result
      });
    case SEND_FEEDBACK_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingSending: false,
        sendFeedbackSuccess: false,
        sendFeedbackFail: action.error ? action.error : action
      });
    default:
      return state;
  }
}

function forgotPass(email) {
  return {
    types: [FORGOT_PASS, FORGOT_PASS_SUCCESS, FORGOT_PASS_FAIL],
    promise: function promise(client) {
      return client.get('/user/forgot-pass?email=' + email);
    }
  };
}

function resetPass(input) {
  return {
    types: [RESET_PASS, RESET_PASS_SUCCESS, RESET_PASS_FAIL],
    promise: function promise(client) {
      return client.post('/user/reset-pass', {
        data: input
      });
    }
  };
}
function updateUser(user, avatar) {
  var token = (0, _localStorage.localStore)().get('token');
  var data = (0, _extends3.default)({}, user, { token: token });
  var attach = [];
  avatar.map(function (img) {
    var obj = {
      key: 'img',
      value: img
    };
    attach.push(obj);
  });
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: function promise(client) {
      return client.post('/user/update', {
        data: data,
        attach: attach
      });
    }
  };
}
function sendFeedback(content, image) {
  var token = (0, _localStorage.localStore)().get('token');
  var data = (0, _extends3.default)({}, content, { token: token });
  var attach = [];
  image.map(function (img) {
    var obj = {
      key: 'img',
      value: img
    };
    attach.push(obj);
  });
  return {
    types: [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAIL],
    promise: function promise(client) {
      return client.post('/feedback/create', {
        data: data,
        attach: attach
      });
    }
  };
}

function activePhone(firebaseToken) {
  return {
    types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
    promise: function promise(client) {
      return client.post('/user/activePhoneFirebase', {
        data: {
          idToken: firebaseToken
        }
      });
    }
  };
}

function clearSuccessStatus() {
  return {
    type: CLEAR_STATUS
  };
}

function saveUserLocation(location) {
  return {
    type: SAVE_USER_LOCATION,
    payload: location
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/user.js
// module id = 68
// module chunks = 0